/* ============================
   VARIANT CHANGE EVENT FIX
   ============================ */

document.addEventListener("change", function (e) {
  const form = e.target.closest('form[action*="/cart/add"]');
  if (!form) return;

  const idInput = form.querySelector('input[name="id"]');
  if (!idInput || !idInput.value) return;

  // Product JSON tap
  const section = form.closest('[id^="Product-"]');
  let jsonEl = null;

  if (section) {
    const secId = section.id.replace("Product-", "");
    jsonEl = document.getElementById("ProductJson-" + secId);
  }

  if (!jsonEl) jsonEl = document.querySelector('script[data-product]');
  if (!jsonEl) return;

  let productData = {};
  try { productData = JSON.parse(jsonEl.textContent); }
  catch { return; }

  const variant = productData.variants.find(
    (v) => String(v.id) === String(idInput.value)
  );

  if (!variant) return;

  // Bütün qalereya sistemlərinə siqnal atır
  document.dispatchEvent(
    new CustomEvent("variant:changed", {
      detail: { variant: variant }
    })
  );
});
